import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class CategoryApi extends EntityApi {
    protected static GET_COLLECTION = "/api/categories";

    protected static POST_COLLECTION = "/api/categories";

    protected static GET_ITEM = "/api/categories/{id}";

    protected static PATCH_ITEM = "/api/categories/{id}";

    protected static DELETE_ITEM = "/api/categories/{id}";

    protected static GET_COLLECTION_GET_CATEGORIES = "/get-categories";

    public static async getCategories<R>(
        page = 1,
        extraParams = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_GET_CATEGORIES,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
